import { differenceInDays } from 'date-fns';
import {
  AccountingJob,
  AccountingJobStateEnum,
  AccountingJobTypeEnum,
} from './types';

const getProgress = (accountingJob: AccountingJob) => {
  let progress = 0;
  let balanceSheetProgress = 0;
  let balanceLogsProgress = 0;
  let revaluationProgress = 0;

  if (
    accountingJob.balancesLogsCurrentDate ||
    accountingJob.balanceSheetCurrentDate ||
    accountingJob.revaluationCurrentDate ||
    accountingJob.postProcessingCurrentDate
  ) {
    let currentDate = '';

    if (
      accountingJob.type === AccountingJobTypeEnum.BALANCE_SHEET &&
      accountingJob.balanceSheetCurrentDate
    ) {
      currentDate = accountingJob.balanceSheetCurrentDate;
    } else if (
      accountingJob.type === AccountingJobTypeEnum.REVALUATION &&
      accountingJob.revaluationCurrentDate
    ) {
      currentDate = accountingJob.revaluationCurrentDate;
    } else if (
      accountingJob.type === AccountingJobTypeEnum.POST_PROCESSING &&
      accountingJob.postProcessingCurrentDate
    ) {
      currentDate = accountingJob.postProcessingCurrentDate;
    }

    if (
      currentDate &&
      accountingJob.type !== AccountingJobTypeEnum.BALANCES_LOGS
    ) {
      const normalizedCurrentDate = currentDate.split('T')[0];
      const normalizedPeriodFrom = accountingJob.periodFrom.split('T')[0];
      const normalizedPeriodTo = accountingJob.periodTo.split('T')[0];

      let diffDays = differenceInDays(
        new Date(normalizedCurrentDate),
        new Date(normalizedPeriodFrom),
      );
      let diffPeriodDays = differenceInDays(
        new Date(normalizedPeriodTo),
        new Date(normalizedPeriodFrom),
      );

      if (
        accountingJob?.state === AccountingJobStateEnum.DONE &&
        diffPeriodDays === 0
      ) {
        diffDays = 1;
        diffPeriodDays = 1;
      }

      if (Number(diffDays / diffPeriodDays) < 1) {
        progress = Number(((diffDays / diffPeriodDays) * 100).toFixed(0));
      } else if (Number(diffDays / diffPeriodDays) >= 1) {
        progress = 100;
      }
    } else if (
      accountingJob.type === AccountingJobTypeEnum.BALANCES_LOGS &&
      (accountingJob?.balanceSheetCurrentDate ||
        accountingJob?.balancesLogsCurrentDate ||
        accountingJob.revaluationCurrentDate)
    ) {
      if (accountingJob?.balanceSheetCurrentDate) {
        const normalizedCurrentDate =
          accountingJob?.balanceSheetCurrentDate.split('T')[0];
        const normalizedPeriodFrom = accountingJob.periodFrom.split('T')[0];
        const normalizedPeriodTo = accountingJob.periodTo.split('T')[0];

        let diffDays = differenceInDays(
          new Date(normalizedCurrentDate),
          new Date(normalizedPeriodFrom),
        );
        let diffPeriodDays = differenceInDays(
          new Date(normalizedPeriodTo),
          new Date(normalizedPeriodFrom),
        );

        if (
          accountingJob?.state === AccountingJobStateEnum.DONE &&
          diffPeriodDays === 0
        ) {
          diffDays = 1;
          diffPeriodDays = 1;
        }

        balanceSheetProgress = Number(
          ((diffDays / diffPeriodDays) * 100).toFixed(0),
        );
      }

      if (accountingJob?.balancesLogsCurrentDate) {
        const normalizedCurrentDate =
          accountingJob?.balancesLogsCurrentDate.split('T')[0];
        const normalizedPeriodFrom = accountingJob.periodFrom.split('T')[0];
        const normalizedPeriodTo = accountingJob.periodTo.split('T')[0];

        let diffDays = differenceInDays(
          new Date(normalizedCurrentDate),
          new Date(normalizedPeriodFrom),
        );
        let diffPeriodDays = differenceInDays(
          new Date(normalizedPeriodTo),
          new Date(normalizedPeriodFrom),
        );

        if (
          accountingJob?.state === AccountingJobStateEnum.DONE &&
          diffPeriodDays === 0
        ) {
          diffDays = 1;
          diffPeriodDays = 1;
        }

        balanceLogsProgress = Number(
          ((diffDays / diffPeriodDays) * 100).toFixed(0),
        );
      }

      if (accountingJob?.revaluationCurrentDate) {
        const normalizedCurrentDate =
          accountingJob?.revaluationCurrentDate.split('T')[0];
        const normalizedPeriodFrom = accountingJob.periodFrom.split('T')[0];
        const normalizedPeriodTo = accountingJob.periodTo.split('T')[0];

        let diffDays = differenceInDays(
          new Date(normalizedCurrentDate),
          new Date(normalizedPeriodFrom),
        );
        let diffPeriodDays = differenceInDays(
          new Date(normalizedPeriodTo),
          new Date(normalizedPeriodFrom),
        );

        if (
          accountingJob?.state === AccountingJobStateEnum.DONE &&
          diffPeriodDays === 0
        ) {
          diffDays = 1;
          diffPeriodDays = 1;
        }

        revaluationProgress = Number(
          ((diffDays / diffPeriodDays) * 100).toFixed(0),
        );
      }

      progress = Math.min(
        ...[
          Number(revaluationProgress),
          Number(balanceLogsProgress),
          Number(balanceSheetProgress),
        ],
      );
    }
  }

  return {
    progress,
    revaluationProgress,
    balanceLogsProgress,
    balanceSheetProgress,
  };
};

export default getProgress;
